import React, { FC } from 'react';
import {
  Typography,
  Link,
  styled,
  SimpleDialog,
} from '@nextiva/next-ui-components';

const StyledLink = styled(Link)`
  &.MuiTypography-root {
    color: ${({ theme }) => theme.palette.primary.main};
  }
  &:hover {
    text-decoration: none;
  }
`;

const StyledSimpleDialog = styled(SimpleDialog)`
  width: 520px;
  margin: 0 auto;
  button.MuiButtonBase-root {
    line-height: 1rem;
  }
`;

const PendingDialog: FC<DialogProps> = ({ open, onClose, handleSMSChange }) => {
  return (
    <StyledSimpleDialog
      data-testid="PlatformAdminUI-PendingModal"
      cancelButtonProps={{
        onClick: onClose,
      }}
      cancelText="Cancel"
      confirmButtonProps={{
        onClick: handleSMSChange,
      }}
      confirmText="Done"
      title="Registration pending"
      open={open}
    >
      <Typography variant="body2">
        Businesses messaging registration is not completed yet. Check the status
        at{' '}
        <StyledLink
          href="/apps/platform-admin/#/messaging"
          rel="noopener"
          data-testid="PlatformAdminUI-PendingModal-RegistrationLink"
        >
          Text Messaging Registration
        </StyledLink>{' '}
        section.
      </Typography>
      <Typography variant="body2" sx={{ margin: '24px 0' }}>
        You can continue messaging internally to your teammates.
      </Typography>
    </StyledSimpleDialog>
  );
};

export default PendingDialog;
